import { BaseResponse } from './../common/BaseResponse';
import { PurchaseOrderId } from '../order';
import { TimeMaterialId } from './TimeMaterialResponse';

export type TimeMaterialShipmentId = string;

export enum TimeMaterialShipmentStatus {
  acknowledged = 'acknowledged',
  shipped = 'shipped',
  opened = 'opened',
  delivered = 'delivered',
}

export interface TimeMaterialShipmentResponse extends BaseResponse {
  id: TimeMaterialShipmentId;
  TimeMaterialId: TimeMaterialId;
  poId: PurchaseOrderId;
  status: TimeMaterialShipmentStatus;
  amount: number;
  items: TimeMaterialShipmentLineItem[];
  shippingMethod: string;
  shippingAccountNo: string;
  trackId: string;
  deliveryDate?: number;
  shippedDate?: number;
  printUrl: string;
}

export interface TimeMaterialShipmentLineItem {
  id: number;
  poLineId: number;
  shipmentId: number;
  qty: number;
}

export interface OrderShipmentRequest extends TimeMaterialShipmentResponse {
  lines: string[];
}
